<template>
  <el-alert
    v-if="showMessage"
    :title="globalMessage.title"
    :type="globalMessage.type"
    :description="globalMessage.content"
    center
    show-icon>
  </el-alert>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    computed: {
      ...mapState(['showMessage', 'globalMessage'])
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/globalmessage.vue